'use strict';

import User from './User';

export default class UserStore {

  users = [];
  userProps = [
    'id', 'fullName', 'login', 'securityPin', 'authTokenAcquired', '2FAVerification', 'csrf', 'loggedIn'
  ];

  constructor() {
    if (localStorage.getItem('usr') === null) {
      this._setDefault();
    }
    this._load();
  }

  getAll() {
    return this.users;
  }

  getById(id) {
    let users = this.getAll().filter(user => user.get('id') === id);
    if (users.length === 1 && typeof users[0] === 'object') {
      return users[0];
    }
    return null;
  }

  getByParam(paramName,paramValue) {
    let users = this.getAll().filter(user => user.get(paramName) === paramValue);
    if (users.length === 1 && typeof users[0] === 'object') {
      return users[0];
    }
    return null;
  }

  getLoggedUser() {
    let logged = null;
    this.users.forEach((user, i) => {
      if (user.get('loggedIn') === true) {
        logged = user;
      }
    });
    return logged;
  }

  has(id) {
    return this.getById(id) !== null;
  }


  addOrPatch(userProps) {
    let user = null;
    if (typeof userProps === 'object' && userProps.hasOwnProperty('id')) {
      if (!this.has(userProps.id)) {
          user = this.add(userProps);
      }
      else {
          user = this.getById(userProps.id).patch(userProps);
      }
    }
    return user;
  }

  add(userProps) {
    let user = null;
    if (typeof userProps === 'object' && userProps.hasOwnProperty('id')) {
      if (!this.has(userProps.id)) {
        user = new User(this, userProps);
        this.users.push(user);
      }
    }
    this._persist();
    return user;
  }

  remove(id) {
    let users = this.getAll();
    users.forEach((user, index) => {
      if (user.get('id') === id) {
        users.splice(index, 1);
      }
    });
    this.users = users;
    this._persist();
    return this;
  }

  clear() {
    this.users = [];
    this._persist();
    return this;
  }

  somebodyIsLoggedIn() {
    let somebodyLogged = false;
    this.users.forEach(user => {
        if(user.get('loggedIn') === true) {
            somebodyLogged = true;
        }
    });
    return somebodyLogged;
  }

  _load() {
    let userData = JSON.parse(localStorage.getItem('usr'));
    userData.forEach((userProps, i) => {
      if (i in this.users) {
        this.users[i].patch(userProps);
      } else {
        this.users[i] = new User(this, userProps);
      }
    });
    return this;
  }

  _persist() {
    let userArr = [];
    this.users.forEach((user, i) => {
      userArr[i] = user.export();
    });
    localStorage.setItem('usr', JSON.stringify(userArr));
    return this;
  }

  _setDefault() {
    localStorage.setItem('usr', JSON.stringify([]));
    return this;
  }

}



// WEBPACK FOOTER //
// ./src/class/UserStore.js